import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import useFeatureAccess from "@app/common/hooks/useFeatureAccess";
import ROUTES from "@app/common/routes";
import useWorkspace from "@app/common/workspaces/useWorkspace";
import * as WorkspaceUtils from "@app/common/workspaces/workspaceUtils";

import AdminWorkspaceActions from "./AdminWorkspaceActions";
import MemberWorkspaceActions from "./MemberWorkspaceActions";
import LeaveConfirmationModal from "../../../../components/LeaveConfirmationModal";
import MigrateMeetingsConfirmationModal from "../../components/MigrateMeetingsConfirmationModal";

const WorkspaceActionsModule = () => {
  const { migrateMeetings, workspaceUser, leaveWorkspace } = useWorkspace();
  const { canEditWorkspaceSettings } = useFeatureAccess();

  const navigate = useNavigate();
  const isTeamManger = WorkspaceUtils.isTeamManager(workspaceUser);

  const [leaveWorkspaceModalOpen, setLeaveWorkspaceModalOpen] = useState(false);
  const [migrateMeetingsModalOpen, setMigrateMeetingsModalOpen] =
    useState(false);

  const handleLeaveWorkspaceConfirm = () => {
    leaveWorkspace.mutate(undefined, {
      onSuccess: () => navigate(ROUTES.USER_SETTINGS_DEFAULT_SECTION),
    });
  };

  const handleMigrateMeetingsConfirm = async () => {
    if (!workspaceUser.userId) {
      return;
    }
    migrateMeetings.mutate(workspaceUser.userId, {
      onSuccess: () => {
        setMigrateMeetingsModalOpen(false);
      },
    });
  };

  const handleOpenLeaveWorkspaceModal = () => setLeaveWorkspaceModalOpen(true);
  const handleOpenMigrateMeetingsModal = () =>
    setMigrateMeetingsModalOpen(true);

  return (
    <>
      <MigrateMeetingsConfirmationModal
        loading={migrateMeetings.isPending}
        open={migrateMeetingsModalOpen}
        onClose={() => setMigrateMeetingsModalOpen(false)}
        onConfirm={handleMigrateMeetingsConfirm}
      />
      <LeaveConfirmationModal
        loading={leaveWorkspace.isPending || leaveWorkspace.isSuccess}
        open={leaveWorkspaceModalOpen}
        onClose={() => setLeaveWorkspaceModalOpen(false)}
        onConfirm={handleLeaveWorkspaceConfirm}
        context="workspace"
      />
      {canEditWorkspaceSettings ? (
        <AdminWorkspaceActions
          onClickMigrateMeetings={handleOpenMigrateMeetingsModal}
          onClickLeaveWorkspace={handleOpenLeaveWorkspaceModal}
        />
      ) : (
        <MemberWorkspaceActions
          isTeamManager={isTeamManger}
          onClickMigrateMeetings={handleOpenMigrateMeetingsModal}
          onClickLeaveWorkspace={handleOpenLeaveWorkspaceModal}
        />
      )}
    </>
  );
};

export default WorkspaceActionsModule;
